import { useEffect } from "preact/hooks";
import { get } from "../../utils/http";

export const CometChat = () => {
	const regID = window.dataLayer[0]["Registrant ID"]
	const fullName = window.dataLayer[0]["First & Last Name"]
	var company = window.dataLayer[0]['Company'];
	var userName = `${fullName} - ${company}`
	const picture = window.dataLayer[0]["Please upload a headshot:"] || "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Linecons_user-avatar.svg/600px-Linecons_user-avatar.svg.png"
	const regUid = regID.toString()

	useEffect(() => {
		window.openDM = chatGuid => {
			window.CometChatWidget.openOrCloseChat(true)
			window.CometChatWidget.chatWithUser(chatGuid);
		}
	})

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			height: "550px",
			// left or right
			roundedCorners: "true",
			widgetID: "c4bda9d3-a11f-432a-94bc-888cc03215dd",
			width: "400px",
		})
		get(`https://backend.swoogo-retrofit.tkevents.io/chat/addToMemberChats`, { id: regUid })
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = () => {
		window.CometChatWidget.init(
			{
				widgetID: "c4bda9d3-a11f-432a-94bc-888cc03215dd",
				appID: "197028a3069aa3a0",
				appRegion: "eu",
				authKey: "",
			}
		).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v3/cometchatwidget.js" />
}

window.openChat = chatGuid => {
	window.CometChatWidget.openOrCloseChat(true)
	window.CometChatWidget.chatWithGroup(chatGuid);
}